export const EChannel = {
  Airbnb: 'airbnb',
  Vrbo: 'vrbo',
  Hosty: 'hosty',
} as const;

export type EChannel = (typeof EChannel)[keyof typeof EChannel];
